import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Section from '../shared/Section';
import { DataBase, Device, Chain, CompleteData, Folder, FileLock, ClientInfo, TransfertData } from './../../assets/img/privacy';
import './the-solution.css';
import { CarFlux, Funnel, Map, WifiBox, Phone, Dashboard, Bus, Bus2, Map2, Clock, Rainbow, Velo, RealTime, ParkAndRide, Fraude, SAE, Billettique, Comptage, Gtfs, FlowlySensors, Infographie } from '../../assets/img/the-solution';

const TheSolution = (): React.JSX.Element => {

    const { t } = useTranslation();

    const navigate = useNavigate();

    return <>
        <Section className="hero-section py-5">
            <div className="text-start title">
                <h2 dangerouslySetInnerHTML={{ __html: t('Pages.Solution.Title')! }} />
                {/* <p dangerouslySetInnerHTML={{ __html: t('Pages.Solution.SubTitle')! }} /> */}
                <p>Flowly accompagne les collectivités et les opérateurs de transports pour améliorer la connaissance des flux de déplacement et analyser les performances du réseau. La plateforme Flowly Data  agrège les données de mobilité disponibles du réseau dans une interface web unique. Les capteurs Flowly Sensors permettent de suivre la fréquentation et les origines-destinations.</p>
                <img src={CarFlux} className='hero-img-mobile'/>
            </div>
        </Section>
        <img src={CarFlux} className='hero-img'/>
        <Section className="py-5">
            <Row className='justify-content-center py-4'>
                <Col xs={12} md={6} className='text-center'>
                    <h4 className="mt-5" dangerouslySetInnerHTML={{ __html: t('Pages.Solution.Title2')! }} />
                    {/* <p style={{fontSize: "20px"}} dangerouslySetInnerHTML={{ __html: t('Pages.Solution.SubTitle2')! }} /> */}
                    <p>FLOWLY Data agrège et analyse l’ensemble des données des réseaux pour les mettre à disposition des collectivités, des opérateurs et des passagers, et les rendre accessibles en continu sur différents types de supports, en fonction des besoins de chacun (smartphone, tablette, PC, API, etc.).</p>
                </Col>
            </Row>
            <Row className='justify-content-center py-4'>
                <Col xs={12} lg={6} className='text-start'>
                    <h4>Comment ça marche ?</h4>
                    <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata t ea rebum. Stet</p>
                </Col>
                <Col xs={12} lg={6} className='text-start'>
                    <h4>À quoi ça sert ?</h4>
                    <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata t ea rebum. Stet</p>
                </Col>
            </Row>
            <Row className='justify-content-center p-0'>
                <Col xs={12} className='text-center p-0' style={{height: "fit-content"}}>
                    <img src={Infographie} style={{width: "75%"}}/>
                </Col>
            </Row>
        </Section>
        <Section className='py-5'>
            <Row className='jusitfy-content-center py-4 position-relative'>
                    <div className="col">
                    <div className="main-timeline">
                        <div className="timeline">
                            <a href="#" className="timeline-content">
                                <div className="timeline-image-wrapper"><img src={FlowlySensors} /></div>
                                <div className="content">
                                    <h4 className="title">Flowly sensors</h4>
                                    <p className="description">
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div className="timeline">
                            <a href="#" className="timeline-content">
                                <div className="timeline-image-wrapper"><img src={Gtfs} /></div>
                                <div className="content">
                                    <h4 className="title">Gtfs</h4>
                                    <p className="description">
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div className="timeline">
                            <a href="#" className="timeline-content">
                                <div className="timeline-image-wrapper"><img src={Comptage} /></div>
                                <div className="content">
                                    <h4 className="title">Comptage</h4>
                                    <p className="description">
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div className="timeline">
                            <a href="#" className="timeline-content">
                                <div className="timeline-image-wrapper"><img src={Billettique} /></div>
                                <div className="content">
                                    <h4 className="title">Billettique</h4>
                                    <p className="description">
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div className="timeline">
                            <a href="#" className="timeline-content">
                                <div className="timeline-image-wrapper"><img src={SAE} /></div>
                                <div className="content">
                                    <h4 className="title">Système d'aide à l'exploitation</h4>
                                    <p className="description">
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div className="timeline">
                            <a href="#" className="timeline-content">
                                <div className="timeline-image-wrapper"><img src={Fraude} /></div>
                                <div className="content">
                                    <h4 className="title">Fraude</h4>
                                    <p className="description">
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div className="timeline">
                            <a href="#" className="timeline-content">
                                <div className="timeline-image-wrapper"><img src={Velo} /></div>
                                <div className="content">
                                    <h4 className="title">Données vélos</h4>
                                    <p className="description">
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div className="timeline">
                            <a href="#" className="timeline-content">
                                <div className="timeline-image-wrapper"><img src={RealTime} /></div>
                                <div className="content">
                                    <h4 className="title">Remontées en temps réel (Conducteurs/Passagers)</h4>
                                    <p className="description">
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div className="timeline">
                            <a href="#" className="timeline-content">
                                <div className="timeline-image-wrapper"><img src={ParkAndRide} /></div>
                                <div className="content">
                                    <h4 className="title">Park and ride</h4>
                                    <p className="description">
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </Row>
        </Section>
        <Section className='bg-light-orange py-5'>
            <Row className='justify-content-center py-4 position-relative'>
                <Col xs={12} md={8} className='text-center'>
                    <img className='rainbow-1' src={Rainbow}/>
                    <h4>Comment ça fonctionne ?</h4>
                    <p style={{fontSize: "20px"}}>Flowly permet de suivre précisément et en continue les flux de déplacements-voyageur dans les bus/métros/trains. <br /> Des capteurs installés dans les véhicules détectent et enregistrent en temps réel les signaux passifs des smartphones. Les passagers sont informés et peuvent s’opposer à la collecte des données.</p>
                </Col>
            </Row>
            <Row className='justify-content-center py-4'>
                <Col xs={12} md={6}>
                    <div className='block text-center'>
                        <div className='image'>
                            <img src={Map} />
                        </div>
                        <div>
                            <p>Flowly permet de suivre précisément et en continu les flux de déplacements-voyageur dans les bus/métros/trains.</p>
                        </div>
                    </div>
                </Col>
                <Col xs={12} md={6}>
                    <div className='block text-center'>
                        <div className='image'>
                            <img src={WifiBox} />
                        </div>
                        <div>
                            <p>Des capteurs installés dans les véhicules détectent et enregistrent en temps réel les signaux passifs des smartphones. Les passagers sont informés et peuvent s’opposer à la collecte des données.</p>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row className='justify-content-center py-4 position-relative'>
                <Col xs={12} md={8}>
                    <p className='text-center' style={{fontSize: "20px"}}>Les données filtrées, anonymisées et croisées aux autres données du réseau Elles sont ensuite mises à la disposition de l’exploitant du réseau sur une plateforme dédiée Les premiers chiffres sont exploitables quelques semaines après la mise en place de Flowly. Nos capteurs peuvent être interfacés avec des cellules de comptage pour compléter l’analyse de l’usage du réseau (origines-destinations et comptages précis et exhaustifs). Les résultats sont mis à la disposition du client (opérateur et/ou collectivité) sur l’interface Flowly Data.</p>
                    <img className='rainbow-2' src={Rainbow}/>
                </Col>
            </Row>
            <Row className='justify-content-center py-4'>
                <Col xs={12} sm={6} lg={4}>
                    <div className='block text-center'>
                        <div className='image'>
                            <img src={Funnel}/>
                        </div>
                        <div>
                            <p>Les données filtrées, anonymisées et croisées aux autres données du réseau</p>
                        </div>
                    </div>
                </Col>
                <Col xs={12} sm={6} lg={4}>
                    <div className='block text-center'>
                        <div className='image'>
                            <img src={Phone}/>
                        </div>
                        <div>
                            <p>Elles sont ensuite mises à la disposition de l’exploitant du réseau sur une plateforme dédiée</p>
                        </div>
                    </div>
                </Col>
                <Col xs={12} sm={6} lg={4}>
                    <div className='block text-center'>
                        <div className='image'>
                            <img src={Dashboard}/>
                        </div>
                        <div>
                            <p>Les premiers chiffres sont exploitables quelques semaines après la mise en place de Flowly.</p>
                        </div>
                    </div>
                </Col>
            </Row>
        </Section>
        <Section className='bg-light-orange py-5'>
            <Row className='justify-content-center py-4'>
                <Col xs={12} md={8} className='text-center'>
                    <h4 dangerouslySetInnerHTML={{ __html: t('Pages.Solution.Title3')! }} />
                    <p style={{fontSize: "20px"}} dangerouslySetInnerHTML={{ __html: t('Pages.Solution.SubTitle3')! }} />
                </Col>
            </Row>
            <Row className='justify-content-center py-4'>
                <Col xs={12} sm={6} lg={4}>
                    <div className='block text-center'>
                        <div className='image'>
                            <img src={Bus}/>
                        </div>
                        <p className='fw-bold'>Point de descente</p>
                    </div>
                </Col>
                <Col xs={12} sm={6} lg={4}>
                    <div className='block text-center'>
                        <div className='image'>
                            <img src={Map}/>
                        </div>
                        <p className='fw-bold'>Correspondances effectuées par les voyageurs</p>
                    </div>
                </Col>
                <Col xs={12} sm={6} lg={4}>
                    <div className='block text-center'>
                        <div className='image'>
                            <img src={Bus2}/>
                        </div>
                        <p className='fw-bold'>Nombre de personnes par véhicule</p>
                    </div>
                </Col>
                <Col xs={12} sm={6} lg={4}>
                    <div className='block text-center'>
                        <div className='image'>
                            <img src={Map2}/>
                        </div>
                        <p className='fw-bold'>Lieu d’origine, destination finale et distance parcourue des usagers</p>
                    </div>
                </Col>
                <Col xs={12} sm={6} lg={4}>
                    <div className='block text-center'>
                        <div className='image'>
                            <img src={Clock}/>
                        </div>
                        <p className='fw-bold'>Temps de parcours de chacun</p>
                    </div>
                </Col>
            </Row>
            <Row className='justify-content-center py-4'>
                <Col xs={12} lg={6} className='text-start'>
                    <h4 style={{fontSize: "24px"}}>Détection des signaux passifs de smartphones</h4>
                    <p>Flowly permet de suivre précisément et en continu les flux de déplacements-voyageur dans les bus/métros/trains.
                    Des capteurs installés dans les véhicules détectent et enregistrent en temps réel les signaux passifs des smartphones. Les passagers sont informés et peuvent s'opposer à la collecte des données.
                    </p>
                </Col>
                <Col xs={12} lg={6} className='text-start'>
                    <h4 style={{fontSize: "24px"}}>Une reconstitution anonyme du trajet</h4>
                    <p>Les données filtrées, anonymisées et croisées aux autres données du réseau
                    Elles sont ensuite mises à la disposition de l'exploitant du réseau sur une plateforme dédiée
                    Les premiers chiffres sont exploitables quelques semaines après la mise en place de Flowly.
                    Nos capteurs peuvent être interfacés avec des cellules de comptage pour compléter l’analyse de l’usage du réseau (origines-destinations et comptages précis et exhaustifs). Les résultats sont mis à la disposition du client (opérateur et/ou collectivité) sur l’interface Flowly Data.
                    </p>
                </Col>
            </Row>
        </Section>
        <Section className="py-5">
            <Row className='justify-content-center py-4'>
                <Col xs={12} md={8} className='text-center'>
                    <h4 dangerouslySetInnerHTML={{ __html: t('Pages.Privacy.Title')! }} />
                    <p style={{fontSize: "20px"}} dangerouslySetInnerHTML={{ __html: t('Pages.Privacy.SubTitle')! }} />
                </Col>
            </Row>
            <Row className='py-4'>
                <Col md={12}  lg={6}>
                    <Row className='align-items-center privacy-card'>
                        <Col xs={12} md={3} className="image-elements pt-3 pt-md-0">
                            <img alt={t('Pages.Privacy.NoCollect.AltImg')} src={Folder} />
                        </Col>
                        <Col md={9}  className='text-center text-md-start'>
                            <p>{t('Pages.Privacy.NoCollect.Description')}</p>
                        </Col>
                    </Row>
                    <Row className='align-items-center privacy-card'>
                        <Col xs={12}  md={3} className="image-elements pt-3 pt-md-0">
                            <img alt={t('Pages.Privacy.ClientInfo.AltImg')} src={ClientInfo} />
                        </Col>
                        <Col md={9} className='text-center text-md-start'>
                            <p>{t('Pages.Privacy.ClientInfo.Description')}</p>
                        </Col>
                    </Row>
                    <Row className='align-items-center privacy-card'>
                        <Col xs={12} md={3} className="image-elements pt-3 pt-md-0">
                            <img alt={t('Pages.Privacy.Device.AltImg')} src={Device} />
                        </Col>
                        <Col md={9} className='text-center text-md-start'>
                            <p>{t('Pages.Privacy.Device.Description')}</p>
                        </Col>
                    </Row>
                    <Row className='align-items-center privacy-card'>
                        <Col xs={12} md={3} className="image-elements pt-3 pt-md-0">
                            <img alt={t('Pages.Privacy.TransfertData.AltImg')} src={TransfertData} />
                        </Col>
                        <Col md={9} className='text-center text-md-start'>
                            <p>{t('Pages.Privacy.TransfertData.Description')}</p>
                        </Col>
                    </Row>
                </Col>
                <Col md={12} lg={6}>
                    <Row className='align-items-center privacy-card'>
                        <Col xs={12} md={3} className="image-elements pt-3 pt-md-0">
                            <img alt={t('Pages.Privacy.DataBase.AltImg')} src={DataBase} />
                        </Col>
                        <Col md={9} className='text-center text-md-start'>
                            <p>{t('Pages.Privacy.DataBase.Description')}</p>
                        </Col>
                    </Row>
                    <Row className='align-items-center privacy-card'>
                        <Col xs={12} md={3} className="image-elements pt-3 pt-md-0">
                            <img alt={t('Pages.Privacy.FileLock.AltImg')} src={FileLock} />
                        </Col>
                        <Col md={9} className='text-center text-md-start'>
                            <p>{t('Pages.Privacy.FileLock.Description')}</p>
                        </Col>
                    </Row>
                    <Row className='align-items-center privacy-card'>
                        <Col xs={12} md={3} className="image-elements pt-3 pt-md-0">
                            <img alt={t('Pages.Privacy.CompleteData.AltImg')} src={CompleteData} />
                        </Col>
                        <Col md={9} className='text-center text-md-start'>
                            <p>{t('Pages.Privacy.CompleteData.Description')}</p>
                        </Col>
                    </Row>
                    <Row className='align-items-center privacy-card'>
                        <Col xs={12} md={3} className="image-elements pt-3 pt-md-0">
                            <img alt={t('Pages.Privacy.Chain.AltImg')} src={Chain} />
                        </Col>
                        <Col md={9} className='text-center text-md-start'>
                            <p>{t('Pages.Privacy.Chain.Description')}</p>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Section>
    </>
};

export default TheSolution;